module.exports = __webpack_public_path__ + "static/media/TASK 2.7c47f699.mp3";